exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video-title[data-v-78c2d436] {\n  max-width: 230px;\n}\n.thumb[data-v-78c2d436] {\n  background-size: cover;\n  background-position: center center;\n  background-color: #999;\n  background-repeat: no-repeat;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n}\n", ""]);

// exports
